import React from 'react';

import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router';
import { AuthServiceInstance } from 'services/authService';

import { UserManagementGeneratedProps } from './UserManagement.props';
import UserManagementView from './UserManagement.view';

const UserManagement = (): JSX.Element => {
  // MARK:- Hooks
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  // MARK:- Query
  const getUsersListQuery = useQuery(
    ['users'],
    AuthServiceInstance.getUserByList,
    {
      onSuccess: () => {
        // Nothing
      },
      onError: () => {
        // TODO:
      },
    }
  );

  // MARK:- Mutation
  const removeAccess = useMutation(AuthServiceInstance.disableUser, {
    onSuccess: () => {
      queryClient.invalidateQueries('users');
    },
    onError: () => {
      // TODO:
    },
  });

  const deleteUser = useMutation(AuthServiceInstance.deleteUser, {
    onSuccess: () => {
      queryClient.invalidateQueries('users');
    },
    onError: () => {
      // TODO:
    },
  });

  const giveAccess = useMutation(AuthServiceInstance.enableUser, {
    onSuccess: () => {
      queryClient.invalidateQueries('users');
    },
    onError: () => {
      // TODO:
    },
  });

  // MARK:- Functions
  function onRemoveAccess(userId: string) {
    removeAccess.mutate({ id: userId });
  }

  function onDeleteUser(userId: string) {
    deleteUser.mutate({ id: userId });
  }

  function onGiveAccess(userId: string) {
    giveAccess.mutate({ id: userId });
  }

  function onClickAddUser() {
    navigate('/dashboard/user-management/add');
  }

  const generatedProps: UserManagementGeneratedProps = {
    users: getUsersListQuery.data?.body || [],
    isFetching: getUsersListQuery.isLoading,
    onRemoveAccess,
    onGiveAccess,
    onClickAddUser,
    onDeleteUser,
  };
  return <UserManagementView {...generatedProps} />;
};

export default UserManagement;
